module.exports = __webpack_public_path__ + "static/media/58.662b5802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/58.jpg
// module id = 426
// module chunks = 0